import { initialAction, initialState } from './initial';

type Reducer = (
  state: typeof initialState,
  action: typeof initialAction,
) => typeof initialState;

const reducer: Reducer = (state, action) => {
  const { type, payload } = action ?? {};

  switch (type) {
    case 'UPDATE_PAYMENT_GATEWAY_ICON':
    case 'UPDATE_PAYMENT_GATEWAY_DISCOUNT_TYPE':
    case 'UPDATE_PAYMENT_GATEWAY_DISCOUNT_AMOUNT': {
      return {
        ...state,
        ...payload,
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer };
